// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scroll {
  overflow-y: scroll;
  overflow-x: hidden;
  height: 110%;
}

.header {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font-size: var(--font-header);
  font-weight: var(--weight-bigger);
  padding: 1rem;
  color: var(--color-primary);
}
.header .--n-f {
  display: block;
}

.body {
  position: relative;
  padding: 1.25rem;
  display: flex;
  align-items: center;
  font-size: var(--font-secondary);
  color: var(--color-primary);
  font-weight: var(--weight-normal);
}
.body.--no-p {
  padding: 0rem;
}
.body.divider:after {
  content: "";
  position: absolute;
  bottom: 0px;
  left: 0;
  width: 100%;
  height: 1px;
  background: var(--app-mid-lighter-2);
}
.body .small {
  font-size: var(--font-secondary);
  color: var(--color-secondary);
}
.body .small.--8 {
  font-size: var(--font-label);
}
.body .title {
  font-size: var(--font-header);
}
.body .image {
  height: auto;
  width: 100px;
}
.body .increment {
  align-self: flex-start;
  display: grid;
  grid-template-columns: 50px 50px 50px;
  border: var(--border-divider);
  border-radius: var(--border-radius);
}
.body .increment ion-button {
  --background-hover: transparent;
  --ripple-color: transparent;
}
.body .increment .inc-input {
  width: 100%;
  border: none;
  border-left: var(--border-divider);
  border-right: var(--border-divider);
  font-size: 1.1em;
  font-weight: 500;
  text-align: center;
  background-color: var(--background);
}
.body .description {
  font-weight: 400;
}
.body .price {
  font-size: var(--font-header);
}`, "",{"version":3,"sources":["webpack://./src/app/components/mobile/recap-invoice/recap-invoice.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,kBAAA;EACA,YAAA;AACF;;AAGA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,6BAAA;EACA,iCAAA;EACA,aAAA;EACA,2BAAA;AAAF;AACE;EACD,cAAA;AACD;;AAGA;EACE,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EAgCA,gCAAA;EACA,2BAAA;EACA,iCAAA;AA/BF;AADE;EACD,aAAA;AAGD;AAEC;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,oCAAA;AAAH;AAIE;EACD,gCAAA;EACA,6BAAA;AAFD;AAIC;EACE,4BAAA;AAFH;AAME;EACD,6BAAA;AAJD;AAWE;EACD,YAAA;EACA,YAAA;AATD;AAYE;EACD,sBAAA;EACA,aAAA;EACA,qCAAA;EACA,6BAAA;EACA,mCAAA;AAVD;AAWC;EAEE,+BAAA;EACA,2BAAA;AAVH;AAaC;EACE,WAAA;EACA,YAAA;EACA,kCAAA;EACA,mCAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mCAAA;AAXH;AAkBE;EACD,gBAAA;AAhBD;AAmBE;EACD,6BAAA;AAjBD","sourcesContent":[".scroll{\n  overflow-y: scroll;\n  overflow-x: hidden;\n  height: 110%;\n}\n\n\n.header{\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  font-size: var(--font-header);\n  font-weight: var(--weight-bigger);\n  padding: 1rem;\n  color: var(--color-primary);\n  & .--n-f{\n\tdisplay: block;\n  }\n}\n\n.body{\n  position: relative;\n  padding: 1.25rem;\n  display: flex;\n  align-items: center;\n\n  &.--no-p{\n\tpadding: 0rem;\n\n  }\n\n  &.divider{\n\t&:after{\n\t  content:\"\";\n\t  position:absolute;\n\t  bottom:0px;\n\t  left:0;\n\t  width:100%;\n\t  height:1px;\n\t  background: var(--app-mid-lighter-2);\n\t}\n  }\n\n  .small{\n\tfont-size: var(--font-secondary);\n\tcolor: var(--color-secondary);\n\n\t&.--8{\n\t  font-size: var(--font-label);\n\t}\n  }\n\n  .title{\n\tfont-size: var(--font-header);\n  }\n\n  font-size: var(--font-secondary);\n  color: var(--color-primary);\n  font-weight: var(--weight-normal);\n\n  .image{\n\theight: auto;\n\twidth: 100px;\n  }\n\n  .increment{\n\talign-self: flex-start;\n\tdisplay: grid;\n\tgrid-template-columns: 50px 50px 50px;\n\tborder: var(--border-divider);\n\tborder-radius: var(--border-radius);\n\tion-button{\n\t  //--background-hover: #FFFFFF;\n\t  --background-hover: transparent;\n\t  --ripple-color: transparent;\n\t}\n\n\t.inc-input{\n\t  width: 100%;\n\t  border: none;\n\t  border-left: var(--border-divider);\n\t  border-right: var(--border-divider);\n\t  font-size: 1.1em;\n\t  font-weight: 500;\n\t  text-align: center;\n\t  background-color: var(--background);\n\t}\n\t& .inc-icon{}\n\n\n  }\n\n  .description{\n\tfont-weight: 400;\n  }\n\n  .price{\n\tfont-size: var(--font-header);\n  }\n\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
